import axios from "axios";
import { getApiUrl } from "./config/apiConfig";

const clearAdminSession = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("username");
  localStorage.removeItem("userRole");
  localStorage.removeItem("userPermissions");
  window.dispatchEvent(new CustomEvent("admin-session-cleared"));
};

const axiosInstance = axios.create({
  baseURL: getApiUrl(),
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use((config) => ({
  ...config,
  baseURL: getApiUrl(),
  headers: {
    ...config.headers,
    ...(localStorage.getItem("token")
      ? { Authorization: `Bearer ${localStorage.getItem("token")}` }
      : {}),
  },
}));

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    const message = String(error?.response?.data?.message || "").toLowerCase();
    const code = String(error?.response?.data?.code || "");
    const hasToken = Boolean(localStorage.getItem("token"));
    const requestUrl = String(error?.config?.url || "");

    const shouldLogout =
      hasToken &&
      status === 401 &&
      requestUrl !== "/admin/signin" &&
      (code === "SESSION_REVOKED" ||
        code === "ADMIN_NOT_FOUND" ||
        message.includes("session has expired") ||
        message.includes("user not found") ||
        message.includes("jwt expired"));

    if (shouldLogout) {
      clearAdminSession();
      if (window.location.pathname !== "/") {
        window.location.assign("/");
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
